import { quickFindResult } from '@/api/index'

export function getSuperSettingUser (data) {
  return quickFindResult.request({
    method: 'post',
    url: '/GetSuperSettingUser',
    data
  })
}

export function showBillDetail (data) {
  return quickFindResult.request({
    method: 'post',
    url: '/ShowBillDetail',
    data,
    iSFromData: true
  })
}
